// import Vue from 'vue'
import axios from 'axios'

axios.defaults.baseURL = 'https://agentbkk.com/agentapi/'
// axios.defaults.baseURL = 'http://localhost:8080/agentapi/'

// Vue.use(axios)



// WEBPACK FOOTER //
// ./src/plugins/axios.js